import * as React from "react";
const SvgMenuDropdownDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 9, height: 5, fill: "none", viewBox: "0 0 9 5", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#8597AD", d: "M.233.333 4.4 4.5 8.567.333z" }));
export default SvgMenuDropdownDown;
